import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <nav className="sticky top-0 z-50 bg-background-950/95 backdrop-blur-md border-b border-background-800/60">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="text-2xl font-heading font-black text-primary-500 tracking-tight">黑料王</span>
              <span className="hidden sm:inline-block text-xs text-foreground-500 bg-background-800 px-2 py-0.5 rounded-full">每天更新</span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "bg-primary-500/20 text-primary-400"
                      : "text-foreground-400 hover:text-foreground-100 hover:bg-background-800"
                  }`
                }
              >
                首页
              </NavLink>
              {categories.map((cat) => (
                <NavLink
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={({ isActive }) =>
                    `px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                      isActive
                        ? "bg-primary-500/20 text-primary-400"
                        : "text-foreground-400 hover:text-foreground-100 hover:bg-background-800"
                    }`
                  }
                >
                  {cat.name}
                </NavLink>
              ))}
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "bg-primary-500/20 text-primary-400"
                      : "text-foreground-400 hover:text-foreground-100 hover:bg-background-800"
                  }`
                }
              >
                关于我们
              </NavLink>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-800/60 bg-background-950/95 backdrop-blur-md">
            <div className="px-4 py-3 flex flex-col gap-1">
              <NavLink
                to="/"
                end
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "bg-primary-500/20 text-primary-400"
                      : "text-foreground-400 hover:text-foreground-100 hover:bg-background-800"
                  }`
                }
              >
                首页
              </NavLink>
              {categories.map((cat) => (
                <NavLink
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                      isActive
                        ? "bg-primary-500/20 text-primary-400"
                        : "text-foreground-400 hover:text-foreground-100 hover:bg-background-800"
                    }`
                  }
                >
                  {cat.name}
                </NavLink>
              ))}
              <NavLink
                to="/about"
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "bg-primary-500/20 text-primary-400"
                      : "text-foreground-400 hover:text-foreground-100 hover:bg-background-800"
                  }`
                }
              >
                关于我们
              </NavLink>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}